"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureFlagsStateFactory = void 0;
var featureFlagsStateFactory = function (config) { return (__assign({ featureFlags: [], loadingFeatureFlags: false }, config)); };
exports.featureFlagsStateFactory = featureFlagsStateFactory;
